import { Zone } from "@fairfleet/geotab";
import { zoneTypeId } from "./zoneTypeId";

/** Rows the list renders at most; the search narrows faster than a long list scrolls. */
export const ZONE_LIST_LIMIT = 200;

export function filterZones(zones: Zone[], search: string, typeId: string | null): Zone[] {
  const needle = search.trim().toLocaleLowerCase("de");
  return zones
    .filter(zone => !typeId || (zone.zoneTypes ?? []).some(type => zoneTypeId(type) === typeId))
    .filter(
      zone =>
        needle === "" ||
        (zone.name ?? "").toLocaleLowerCase("de").includes(needle) ||
        (zone.comment ?? "").toLocaleLowerCase("de").includes(needle),
    )
    .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", "de"));
}

/** Nominatim writes "3, Hafenstraße, Bremen"; a zone name reads better as "Hafenstraße 3". */
export function suggestZoneName(addressLabel: string): string {
  const [first = "", second] = addressLabel.split(",").map(part => part.trim());
  return /^\d+\s*\w?$/.test(first) && second ? `${second} ${first}` : first;
}
